// src/components/vault/documents/id-validation/RejectedState.tsx

import React from "react";
import { XCircle, AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "../../../ui/alert";
import { InvalidReasonDisplay } from "../../ui/InvalidReasonDisplay";

interface RejectedStateProps {
  invalidReason: string | null;
}

/**
 * UI component for rejected/invalid state (<60% confidence or failed attributes)
 * Shows error message and tips for better photo
 * Does NOT include upload form - parent component renders that below
 */
export const RejectedState: React.FC<RejectedStateProps> = ({
  invalidReason,
}) => {
  const hasReason = !!invalidReason;

  return (
    <div className="space-y-6 mb-8">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-10 h-10 bg-red-100 rounded-full">
          <XCircle className="w-5 h-5 text-red-600" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          Identificacion rechazada
        </h2>
      </div>

      {/* Rejection reason */}
      {hasReason && (
        <Alert className="bg-red-50 border-red-200">
          <AlertTriangle className="h-4 w-4 text-red-600" />
          <AlertDescription className="text-red-800">
            <span className="font-medium">Motivo del rechazo:</span>
            <br />
            <InvalidReasonDisplay reason={invalidReason} />
          </AlertDescription>
        </Alert>
      )}

      {/* Tips */}
      <div className="bg-gray-50 rounded-lg p-4">
        <p className="text-sm text-gray-700 mb-2">
          Por favor, vuelve a subir tu identificacion asegurandote de que:
        </p>
        <ul className="text-sm text-gray-600 space-y-1">
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0" />
            La imagen sea clara y nitida
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0" />
            Las 4 esquinas del documento sean visibles
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0" />
            No haya reflejos ni sombras
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0" />
            El documento no este expirado
          </li>
        </ul>
      </div>
    </div>
  );
};
